export default "__VITE_ASSET__3h6JbiNT__"